
// ******** Inga forms
import store from "../../index.js"

export default {
  name:'Inga',
  active: true,
  documentTitle:'Inga Formulaires',
  navbarTitle:'Inga Formulaires',//not used for now
  couchdbUrls: ['https://db.inga-forms.aecom.space/'],
  databaseSystem:'a_forms_system',
  pouhdb_replicate_batch_size:5, //default to 100, but crash in browser with photos.
  serial_position_active:false,
  inputGeopointDirectGpsClickAllowed:true,//this by pass the map.
  new_db_couchdb_security_users:"users",
  disableEditingOnOtherDevice: true,
  sql_params:{
    api_url: 'https://api.inga-forms.aecom.space/graphql',
    login_suffix: '@couchdb.sys',
    auto_sync_changes: true, // if we automatically create the record so nodesync will begin sync
    // todo: implement those options
    auto_sql_creation: true, // 
    auto_sql_creation_options:{ // same options possible as the sql.vue
      namebyform: true,
      selectManyTable: true,
      attachements: true,
      attachmentsView: true,
    }
  },
  allowDownloadSurveys: true,
  default_language: 'fr',
  initTasks: [
    // TODO: we should return a funciton that returns a promise that does what it needs to do.
  ],
}
